/// <amd-module name="Search/ExtensionStatus/Constants" />

export const EntityTypeUrlParam = "code";
export const DefaultServiceDataKey = "ms.vss-extmgmt-web.manageExtensions-collection-data-provider";
export const emsServiceInstanceId = "00000028-0000-8888-8000-000000000000";
export const galleryServiceInstanceId = "00000029-0000-8888-8000-000000000000";
export const DefaultMarketplaceUrl = "https://marketplace.visualstudio.com/";
export const extensionId = "vss-code-search";
export const publisherId = "ms";
export const extensionName = "Code Search";

export namespace CustomerIntelligenceConstants {
    export const ExtensionStatusLoaded = "ExtensionStatusLoaded";
    export const ExtensionStatusLoadFailed = "ExtensionStatusLoadFailed";
    export const ExtensionStatusNavigateToMarketplace = "ExtensionStatusNavigateToMarketplace";
}